import "../style.css";
import BackgroundImage from "../../../components/ui/BackgroundImage";
import pilotBackground from "../assets/images/background.webp";
import Text from "../../../components/ui/Text";
import TransportCardsList from "./TransportCardsList";
import SkillProgress from "./SkillProgress";
import { motion, AnimatePresence } from "framer-motion";

interface Props {
  className?: string;
  title?: string;
  description?: string;
}

const PilotJobUpgrade = ({
  className = "",
  title = "PILOT",
  description = "Curse",
}: Props) => {
  return (
    <BackgroundImage imageSrc={pilotBackground} className={`${className}`}>
      <AnimatePresence>
        <div className="h-screen w-full flex flex-col justify-between pt-[8em] overflow-hidden">
          {/** Heading */}
          <motion.div
            key="animated-box"
            initial={{ opacity: 0, y: 50 }} // start position (below)
            animate={{ opacity: 1, y: 0 }} // visible
            exit={{ opacity: 0, y: 50 }} // leave down
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="text-center"
          >
            <h1
              style={{ lineHeight: "1" }}
              className={`text-[110px] 1520px:text-[155px] monument-font  font-thin text-transparent bg-clip-text pilot-text-gradient  stroke-pilot-text text-center ${className}`}
            >
              {title}
            </h1>
            <Text
              size="xs"
              className="gilroy-font text-white uppercase tracking-[52px]"
            >
              {description}
            </Text>
          </motion.div>

          {/** Cards */}
          <motion.div
            key="animated-box"
            initial={{ opacity: 0, y: 50 }} // start position (below)
            animate={{ opacity: 1, y: 0 }} // visible
            exit={{ opacity: 0, y: 50 }} // leave down
            transition={{ duration: 0.4, ease: "easeOut", delay: 0.25 }}
            className="text-center"
          >
            <TransportCardsList className="max-w-[75%] mx-auto mt-10" />
          </motion.div>

          {/** Indikator */}
          <motion.div
            initial={{ opacity: 0, y: 50 }} // start position (below)
            animate={{ opacity: 1, y: 0 }} // visible
            exit={{ opacity: 0, y: 50 }} // leave down
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <SkillProgress
              level={5}
              percentage={35}
              maxLevel={30}
              className="min-w-[50px] min-h-[150px]"
            />
          </motion.div>
        </div>
      </AnimatePresence>
    </BackgroundImage>
  );
};

export default PilotJobUpgrade;
